import { DropdownField } from "../pages/HomeAdmin/components/AdminUsers/models/adminUsers.model";

export const roles: DropdownField[] = [
  { name: "Usuario", code: "user" },
  { name: "Administrador", code: "admin" },
];
